import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { LoadingButton } from '@mui/lab';
import { useAuthenticationContext } from '../context/AuthenticationContextProvider';
import CardProductComponent from './_components/CardProduct';
import LogoEducationColor from 'assets/images/logoProdutos/Education/logo-alert-AI-segmentos_MPE_logo-edu-escuro (1).png';
import LogoEducationWhite from 'assets/images/logoProdutos/Education/logo-alert-AI-segmentos_MPE_logo-edu-negativo (1).png';
import LogoRetailColor from 'assets/images/logoProdutos/Retail/logo-alert-AI-segmentos_MPE_logo-ret-escuro (1).png';
import LogoRetailWhite from 'assets/images/logoProdutos/Retail/logo-alert-AI-segmentos_MPE_logo-ret-negativo (1) (1).png';
import LogoTrafficColor from 'assets/images/logoProdutos/Traffic/logo-alert-AI-segmentos_MPE_logo-tra-escuro (1) (1).png';
import LogoTrafficWhite from 'assets/images/logoProdutos/Traffic/logo-alert-AI-segmentos_MPE_logo-tra-negativo (1).png';
import { Controller } from 'react-hook-form';
import BasicLayout from '../_components/BasicLayout';
import { RegisterFormSchema } from 'services/AuthService/schemas';
import Grid from '@mui/material/Grid';
import { useMediaQuery, useTheme } from '@mui/material';
import zod from 'zod';

type SignUpFormData = zod.infer<typeof RegisterFormSchema>;

const SignUpProductPage = () => {
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useAuthenticationContext();

  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(1000));

  const onSubmit = (data: SignUpFormData) => {
    if (data) {
      navigate('/app/authentication/Welcome');
    }
  };

  return (
    <BasicLayout>
      <Card
        sx={{
          width: '100%',
          height: '95%',
          backgroundColor: 'transparent',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '20%',
          }}
        >
          <Typography color="white" variant="h5" marginY={'0px'}>
            Escolha seu produto
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            marginTop: { md: '0vh' },
            width: '100%',
            height: '65%',
          }}
        >
          <Grid
            container
            columns={isSmallScreen ? 4 : 2}
            justifyContent="center"
            spacing={isSmallScreen ? 2 : 4}
            direction={isSmallScreen ? 'row' : 'column'}
            alignItems="center"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              width: '100%',
              height: '100%',
              margin: '0 auto',
              padding: '0 20px',
            }}
          >
            <Grid item xs={2}>
              <Controller
                control={control}
                name={'product'}
                render={({ field: { value, onChange } }) => (
                  <CardProductComponent
                    backgroudCard={
                      'linear-gradient(180deg, rgba(26,32,48,1) 35%, rgb(78, 0, 112) 98%)'
                    }
                    onClick={() => {
                      setValue('product', 'EDUCATION');
                      setValue('plans', ['EDUCATION_BASIC']);
                      handleSubmit(onSubmit)();
                    }}
                    image={LogoEducationWhite}
                    imageHover={LogoEducationColor}
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <Controller
                control={control}
                name={'product'}
                render={({ field: { value, onChange } }) => (
                  <CardProductComponent
                    backgroudCard={
                      'linear-gradient(180deg, rgba(26,32,48,1) 35%, rgb(0, 112, 11) 98%)'
                    }
                    onClick={() => {
                      setValue('product', 'EDUCATION');
                      setValue('plans', [`EDUCATION_BASIC`]);
                      handleSubmit(onSubmit)();
                    }}
                    image={LogoEducationWhite}
                    imageHover={LogoEducationColor}
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <Controller
                control={control}
                name={'product'}
                render={({ field: { value, onChange } }) => (
                  <CardProductComponent
                    backgroudCard={
                      'linear-gradient(180deg, rgba(26,32,48,1) 35%, rgb(174, 36, 1) 98%)'
                    }
                    onClick={() => {
                      setValue('product', 'RETAIL');
                      setValue('plans', ['RETAIL_BASIC']);
                      handleSubmit(onSubmit)();
                    }}
                    image={LogoRetailWhite}
                    imageHover={LogoRetailColor}
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <Controller
                control={control}
                name={'product'}
                render={({ field: { value, onChange } }) => (
                  <CardProductComponent
                    backgroudCard={
                      'linear-gradient(180deg, rgba(26,32,48,1) 35%, rgb(174, 99, 1) 98%)'
                    }
                    onClick={() => {
                      setValue('product', 'TRAFFIC');
                      setValue('plans', ['TRAFFIC_BASIC']);
                      handleSubmit(onSubmit)();
                    }}
                    image={LogoTrafficWhite}
                    imageHover={LogoTrafficColor}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Box>
        <Box
          mt={1}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '15%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <LoadingButton
              type="submit"
              color="primary"
              variant="contained"
              loadingPosition="center"
              href="signUp"
              sx={{
                width: '100px',
              }}
            >
              Voltar
            </LoadingButton>
          </Box>
        </Box>
      </Card>
    </BasicLayout>
  );
};

export default SignUpProductPage;
